<template>
  <div class="container">
    <div>
      <el-form ref="searchForm" :model="forms" class="search-form">
        <el-form-item label="用劵用户手机号">
        <el-input
          v-model="forms.thirdBuyer"
          placeholder="用劵用户手机号"
          style="width: 200px"
        ></el-input>
        </el-form-item>
        <el-form-item label="优惠券名称">
        <el-input
          v-model="forms.couponName"
          placeholder="优惠券名称"
          style="width: 200px"
        ></el-input>
        </el-form-item>
        <el-form-item label="优惠券状态">
          <el-select v-model="forms.status" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用券时间">
          <el-date-picker
            v-model="forms.useTimeArr"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="用券开始日期"
            end-placeholder="用券结束日期"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions('useTimeArr')"
            @blur="blur('useTimeArr')"
            @change="changeTimesValueEnd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="领券时间">
          <el-date-picker
            v-model="forms.receiveTimeArr"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="领券开始日期"
            end-placeholder="领券结束日期"
            :default-time="['00:00:00', '23:59:59']"
            @change="changeTimesValue"
            :picker-options="pickerOptions('receiveTimeArr')"
            @blur="blur('receiveTimeArr')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="核销券码">
          <el-input
            v-model="forms.code"
            placeholder="核销券码"
            style="width: 200px"
          ></el-input>
        </el-form-item>

        <el-form-item label="天猫券订单号">
          <el-input
            v-model="forms.thirdOrderId"
            placeholder="天猫券订单号"
            style="width: 200px"
          ></el-input>
        </el-form-item>

        <el-form-item label="用券影票订单号">
        <el-input
          v-model="forms.orderId"
          placeholder="用券影票订单号"
          style="width: 200px"
        ></el-input>
        </el-form-item>
        <el-form-item label="退款状态">
          <el-select v-model="forms.refundStatus" placeholder="请选择">
            <el-option
              v-for="item in refundStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
        <el-button type="warning" @click="search">查询</el-button>
        <el-button type="warning" plain @click="reset">重置</el-button>
        <el-button @click="exportTable">导出数据</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      v-loading="loadingDy"
      :data="dyTableList.list"
      border
      highlight-current-row
      style="width: 100%"
      header-row-class-name="header"
    >
      <el-table-column
        v-for="(item, index) in tableDataDy"
        :key="index"
        :prop="item.value"
        :label="item.text"
        align="center"
        :width="
          [
            'thirdBuyer',
            'createTimeStr',
            'useTimeStr',
            'couponCode',
            'outerId',
            'useCouponTime'
          ].includes(item.value)
            ? 175
            : '' || ['status','originalPrice','payPrice','refundStatus'].includes(item.value) ? 90 : '' || ['couponName','orderId','code','thirdOrderId'].includes(item.value) ? 250 : ''
        "
      >
<!--        <template slot-scope="{ row }">-->

<!--          <span-->
<!--            v-if="item.value === 'status'"-->
<!--          >-->
<!--            <span v-if="row.status === 0">未使用</span>-->
<!--            <span v-if="row.status === 1">已使用</span>-->
<!--            <span v-if="row.status === 2">已核销</span>-->
<!--          </span>-->
<!--          <span-->
<!--            v-else-if="item.value === 'refundStatus'"-->
<!--          >-->
<!--            <span v-if="row.refundStatus === 0">未退款</span>-->
<!--            <span v-if="row.refundStatus === 1">已退款</span>-->
<!--          </span>-->
<!--          <span v-else>{{ row[item.value] }}</span>-->
<!--        </template>-->
      </el-table-column>
    </el-table>
    <!--    分页-->
    <el-pagination
      v-if="dyTableList.total > 0"
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="dyTableList.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="dyTableList.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="dyTableList.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import {formatDate,lastSevenDays} from '@/utils/tool.js'
import { tableColumn } from "./enum";
import mini from "@/api/mini";
const MiniModel = new mini();
export default {
  data() {
    return {
      couponPlatformType:'60',
      loadingDy:false,
      tableDataDy:tableColumn,
      dyTableList:{},
      searchForm:{
        pageSize: 10,
        pageNo: 1,
      },
      forms: {
        thirdBuyer: "",
        couponName: "",
        status: "", //券使用状态 0-未使用 1-已使用 2已核销
        useTimeArr: "", //用券时间
        receiveTimeArr: "", //领券时间
        code:'', //核销码
        thirdOrderId:'', //天猫券订单号
        orderId:'', //影片订单号
        refundStatus: "", //券退款状态 0-未退款 1-已退款
      },
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "待使用",
        },
        {
          value: "1",
          label: "已使用",
        },
        {
          value: "2",
          label: "已核销",
        },
      ],
      refundStatusOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "未退款",
        },
        {
          value: "1",
          label: "已退款",
        },
      ],
      pickerStateMap:{}
    };
  },
  computed: {
    isHoliday() {
      return this.$store.getters.isHoliday
    },
  },
  mounted() {
    this.setDefault()
  },
  methods: {
    setDefault() {
      const {start,end} = lastSevenDays(7)
      this.forms.useTimeArr = [start,end]
    },
    // 限制时间范围
    pickerOptions(key) {
      if (!this.pickerStateMap[key]) {
        this.$set(this.pickerStateMap, key, {
          tempStartDate: null,
        })
      }
      return {
        onPick: ({minDate, maxDate}) => {
          if(!this.isHoliday) return
          // console.log(minDate, maxDate,'onPickonPick')
          const state = this.pickerStateMap[key]
          // 只选了第一个时间
          if (minDate && !maxDate) {
            state.tempStartDate = minDate
          }
          // 选完 or 清空
          if (!minDate && !maxDate) {
            state.tempStartDate = null
          }
        },
        disabledDate: (time) => {
          if(!this.isHoliday) return
          // console.log(time,'disabledDatedisabledDate',this.isHoliday)
          const state = this.pickerStateMap[key]
          if (!state.tempStartDate) {
            return false
          }
          const day = 30
          const sixMonth = day * 24 * 3600 * 1000
          const startTime = state.tempStartDate.getTime()

          return (
            time.getTime() <= startTime - sixMonth ||
            time.getTime() >= startTime + sixMonth
          )
        }
      }
    },
    blur(key) {
      console.log(key,'blur==',this.isHoliday)
      // this.tempStartDate = null
      this.pickerStateMap[key].tempStartDate = null
    },
    changeTimesValue(e) {
      console.log(e, "ee=1");
    },
    changeTimesValueEnd(e) {
      console.log(e, "ee=2");
    },
    search() {
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 10
      this.getDyList()
    },
    reset() {
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 10
      this.forms.thirdBuyer = ''
      this.forms.couponName = ''
      this.forms.status = ''
      this.forms.orderId = ''
      this.forms.receiveTimeArr = ""
      this.forms.useTimeArr = ""
      this.forms.code = ''
      this.forms.thirdOrderId = ''
      this.forms.refundStatus = ''
      this.setDefault()
      this.getDyList()
    },
    init() {
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 10
      // this.reset()
      this.getDyList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val;
      this.getDyList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val;
      this.getDyList();
    },
    getParams() {
      let params = {
        pageNo:this.searchForm.pageNo,
        pageSize:this.searchForm.pageSize,
        thirdBuyer:this.forms.thirdBuyer,
        appKey:localStorage.getItem("appKeyMini"),
        ...this.forms,
        couponPlatformType: this.couponPlatformType,
      }
      console.log('ertt==11')
      params.createTimeStart = this.forms.receiveTimeArr ? this.forms.receiveTimeArr[0] : ''
      params.createTimeEnd = this.forms.receiveTimeArr ? this.forms.receiveTimeArr[1] : ''
      params.useTimeStart = this.forms.useTimeArr ? this.forms.useTimeArr[0] : ''
      params.useTimeEnd = this.forms.useTimeArr ? this.forms.useTimeArr[1] : ''
      delete params.receiveTimeArr
      delete params.useTimeArr
      return params
    },
    // 抖音-优惠券使用情况列表
    async getDyList() {
      console.log(this.forms,'forms')
      let params= this.getParams()
      console.log(params,'params')
      // this.dyTableList = {}
      // return
      this.loadingDy = true
      const res = await MiniModel.couponSearchMarket(params).finally(()=> {
        this.loadingDy = false
      })
      console.log(res,'天猫-优惠券使用情况列表')
      if(res.data.code == 200) {
        this.dyTableList = res.data.data
        this.dyTableList.list = res.data.data.list.map(item => {
          return{
            ...item,
            initPrice: item.initPrice === null ? '' : (item.initPrice / 100).toFixed(2),
            payPrice: item.payPrice === null ? '' : (item.payPrice / 100).toFixed(2),
            guidePrice: item.guidePrice === null ? '' : (item.guidePrice / 100).toFixed(2),
            // guidePrice: (item.guidePrice / 100).toFixed(2),
          }
        })
        console.log(this.dyTableList,'this.dyTableList')
      }else{
        this.$message.error(res.data.message)
        this.dyTableList = []
      }
    },
    async exportTable() {
      let params= this.getParams()
      console.log(params,'params')
      const res = await MiniModel.couponExportV3Market(params)
      console.log(res,'导出')
      const code = res.data.code
      const message = res.data.message
      if (code === 200) {
        await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
          showCancelButton: true,
          confirmButtonText: '前往导出列表',
          cancelButtonText: '取消',
          callback: action => {
            if(action === 'confirm'){
              this.$router.push({ path: "/pc/exportCenter/index" });
            }
            this.exportLoading = false
          }
        });
      } else {
        this.$Message.error(message)
      }
    },
  }
};
</script>

<style lang="less" scoped>
/deep/.el-range-separator {
  width: 10% !important;
}
.pagination {
  margin-top: 15px;
  text-align: right;
}
.status {
  display: block;
  position: relative;
  &::before {
    content: "";
    float: left;
    width: 6px;
    height: 6px;
    background: #ff8622;
    border-radius: 50%;
    margin-top: 8px;
  }
  &.green::before {
    background: #51c456;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponTaoBaoNew/component/couponTaoBaoDetail.vue